import { render, staticRenderFns } from "./FormGroupRadio.vue?vue&type=template&id=8f41d9a0"
import script from "./FormGroupRadio.vue?vue&type=script&lang=js"
export * from "./FormGroupRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports